module.exports = __webpack_public_path__ + "static/media/new_shape.9c802a05.png";